import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import Drawer from '@/components/common/Drawer.vue'
import { oemUrl } from './const'
import AdditionCom from './addition/index.vue'
import micro from '@micro-zoe/micro-app'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'product'],
  emits: ['update:visible', 'updateNum'],
  setup(__props, { emit }) {

const props = __props



const sonData: any = ref({})
const url = oemUrl + 'oem/utility/Calculator/Detail'
const title = ref('')
const additionComRef = ref()
const onChange = (data: any) => {
  sonData.value = data.detail.data?.data
  const { type, addition, noAdditionalFlag, isGroup, noSpot, product } = data.detail.data?.data
  if (['AdtOrder', 'DeliAdt'].includes(type)) {
    additionComRef.value.open({
      type,
      addition,
      noAdditionalFlag,
      isGroup,
      noSpot,
      product
    })
  }
}

const close = () => {
  emit('update:visible', false)
}

const updateNum = () => {
  props.product.skuList.forEach((v: any) => {
    emit('updateNum', v)
  })
}
const handleAdt = (addition: any) => {
  micro.setData('my-app', {
    data: {
      addition: addition,
      type: sonData.value.type
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_micro_app = _resolveComponent("micro-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_micro_app, {
      name: "my-app",
      url: url,
      onDatachange: onChange,
      destroy: ""
    }),
    _createVNode(AdditionCom, {
      ref: (_value, _refs) => {
        _refs['additionComRef'] = _value
        additionComRef.value = _value
      },
      onChange: handleAdt
    }, null, 512)
  ], 64))
}
}

})